// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e7-j";
export var fulfillmentFormRail = "_e7-i";
export var headerTitleRow = "_e7-l";
export var orderDetailsWrapper = "_e7-g";
export var orderLinkTrigger = "_e7-2";
export var paymentInformationGrid = "_e7-q";
export var paymentSummaryColumn = "_e7-r";
export var phoneShipmentPickerButton = "_e7-e";
export var phoneShipmentPickerButtonContent = "_e7-f";
export var phoneShipmentPickerButtonWrapper = "_e7-d";
export var phoneShipmentPickerTrigger = "_e7-c";
export var shipmentContainer = "_e7-k";
export var shipmentDetailsMainPane = "_e7-h";
export var shipmentNavigationCard = "_e7-a";
export var shipmentNavigationEdgeTrigger = "_e7-6";
export var shipmentNavigationRail = "_e7-3";
export var shipmentNavigationRailEnter = "_e7-5";
export var shipmentNavigationRailHeader = "_e7-9";
export var shipmentNavigationRailOverlay = "_e7-4";
export var shipmentNavigationScrim = "_e7-7";
export var shipmentSummaryFact = "_e7-n";
export var shipmentSummaryGrid = "_e7-m";
export var shipmentSummaryMetadataRow = "_e7-o";
export var shipmentSummaryTags = "_e7-p";
export var shipmentWorkspace = "_e7-0";
export var shipmentWorkspaceBodyTablet = "_e7-8";
export var shipmentWorkspaceContent = "_e7-b";
export var shipmentWorkspaceHeader = "_e7-1";